export const dataUsuarioVacio = {
  correo: "",
  cedula: "",
  nombres: "",
  apellidos: "",
  sucursal: "",
  errorDescripcion: "",
  cliCodigoCore: "", //agregado cuando se necesito hacer publica la pagina de confirmacion final de pago
  userIsLoggedIn: false,
  isSuscriptor: false,
  sso: false,
  jwtDecoded: null,
};

export const empresa = "AIGMEX";